var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('div',{staticClass:"settings"},[_vm._l((_vm.settings.examples),function(ref,index){
var theme = ref.theme;
var num = ref.num;
return _c('div',[_c('span',[_vm._v(_vm._s(_vm.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples'))+":\n"+_vm._s(num))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.$i18n.t('trainer.trainer_gameFormSetting_themeForExample', {example: null}))+":\n"+_vm._s(_vm.getThemeName(theme.name)))]),_c('br')])}),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }